import { render, staticRenderFns } from "./SimpleSelectList.vue?vue&type=template&id=8e706330&lang=pug&"
import script from "./SimpleSelectList.vue?vue&type=script&lang=js&"
export * from "./SimpleSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports